import request from '@/utils/request'

/**
 * 获取商家购买记录列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listCouponShopPoolDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/couponShopPoolDetail.listCouponShopPoolDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}